<template>
	<form-item class="form_input" :label="$attrs.label">
		<p v-if="preview" class="preview_text">{{ $attrs.value }}</p>
		<van-field v-else class="input__inner" v-bind="$attrs" v-on="$listeners" :placeholder="getPlaceholder">
			<template #extra v-if="showExtraSlot">
				<span class="input__inner_suffix">{{ suffix }}</span>
			</template>
		</van-field>
	</form-item>
</template>

<script>
	export default {
		name: 'FormInput',
		props: {
			suffix: {
				type: String,
				default: ''
			},
			preview: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			showExtraSlot () {
				if (this.suffix) return true
				return false
			},
			getPlaceholder () {
				if (this.$attrs.placeholder) return this.$attrs.placeholder
				return `请输入${this.$attrs.label}`
			}
		}
	}
</script>

<style scoped lang="less">
	.form_input {
		.preview_text {
			word-break: break-all;
			line-height: 42px;
			font-family: PingFangSC-Regular;
			font-size: 30px;
			font-weight: normal;
		}
		.input__inner {
			min-height: 100px;
			align-items: center;
			border-radius: 16px;
			background-color: #F5F6F7;
			.input__inner_suffix {
				padding-left: 10px;
				font-family: PingFangSC-Regular;
				font-size: 30px;
				font-weight: normal;
				line-height: 42px;
				color: #1F2329;
			}
		}
	}
</style>
<style lang="less">
	.form_input {
		.input__inner {
			.van-field__label { display: none; }
			.van-field__value {
				.van-field__control {
					min-height: 42px;
					line-height: 42px;
					font-family: PingFangSC-Regular;
					font-size: 30px;
					font-weight: normal;
				}
			}
		}
	}
</style>
